import { CodeReferenceVm } from '@bfy/bfy-ui-shared';

export class PreEnrollEnrollmentRequestVm {
    //Personal Information section
    public planId?: string;
    public firstName?: string;
    public lastName?: string;
    public suffix?: string;
    public ssn?: string;
    public dob?: string;
    public address1?: string;
    public address2?: string;
    public address3?: string;
    public city?: string;
    public state?: string;
    public zip?: string;
    public personalEmail?: string;
    public personalEmailOptOut = false;
    public participantPlanOptOut = false;
    //Contributions section
    public preTaxPercent?: number;
    public preTaxAmount?: number;
    public preTaxAnnualIncreaseAllowed = false;
    public preTaxAnnualIncreasePerYear?: number;
    public preTaxAnnualIncreaseMaximum?: number;
    public preTaxStartMonth?: string;
    public preTaxIncreaseYear?: string;
    public rothPercent?: number;
    public rothAmount?: number;
    public rothAnnualIncreaseAllowed = false;
    public rothAnnualIncreasePerYear?: number;
    public rothAnnualIncreaseMaximum?: number;
    public rothStartMonth?: number;
    public rothIncreaseYear?: number;
    public preTaxBonusPercent?: number;
    public preTaxBonusAmount?: number;
    public preTaxBonusAnnualIncreaseAllowed = false;
    public preTaxBonusAnnualIncreasePerYear?: number;
    public preTaxBonusAnnualIncreaseMaximum?: number;
    public preTaxBonusStartMonth?: number;
    public preTaxBonusIncreaseYear?: number;
    public rothBonusPercent?: number;
    public rothBonusAmount?: number;
    public rothBonusAnnualIncreaseAllowed = false;
    public rothBonusAnnualIncreasePerYear?: number;
    public rothBonusAnnualIncreaseMaximum?: number;
    public rothBonusStartMonth?: number;
    public rothBonusIncreaseYear?: number;
    public afterTaxPercent?: number;
    public afterTaxAmount?: number;
    public afterTaxAnnualIncreaseAllowed = false;
    public afterTaxAnnualIncreasePerYear?: number;
    public afterTaxAnnualIncreaseMaximum?: number;
    public afterTaxStartMonth?: number;
    public afterTaxIncreaseYear?: number;
    //Allocations section
    public fundDetails!: PreEnrollmentFundAllocationVm[];
    //Signature section
    public signature?: string;
    public constructor(init?: Partial<PreEnrollEnrollmentRequestVm>) {
        Object.assign(this, init);
    }
}

//below classes gets the details entered during admin side pre-enrollment
export class PreEnrollmentDetailsVm {
    preEnrollmentDetails!: PreEnrollmentDetailVm;
    fundDetails!: preEnrollmentFundDetailVm[];
    assetCategories!: preEnrollmentAssetCategoryDetailsVm[];
    showPerformance!: boolean;
    planYearEnd!: Date;
    planName!: string;
}

export class FundInformationVm {
    public fundName!: string;
    public cusip!: string;
    public ticker!: string;
    public defaultFund!: boolean;
    public isValidCusip!: boolean;
}

export class PreEnrollmentDetailVm {
    public preEnrollPlanId!: string;
    public planId!: string;
    public onlineContributionAllowed?: boolean;
    public contributionMethod!: string;
    public preTax?: boolean;
    public roth?: boolean;
    public bonusPreTax?: boolean;
    public bonusRoth?: boolean;
    public afterTax?: boolean;
    public contributionMinAmount?: number;
    public contributionMaxAmount?: number;
    public contributionMinPercent?: number;
    public contributionMaxPercent?: number;
    public fractionalContributionAllowed?: boolean;
    //AutoEnroll Properties
    public autoEnrollAllowed?: boolean;
    public autoEnrollProvision?: string;
    public deferralPercent?: number;
    public deferralAmount?: number;
    public effectiveDate?: Date;
    //AutoIncrease
    public employerAutoIncreaseAllowed?: boolean;
    public employerIncreasePercent?: number;
    public employerIncreaseAmount?: number;
    public employerDeferralPercent?: number;
    public employerDeferralAmount?: number;
    public employerIncreaseDate?: string;
    public employerIncreaseCustom?: string;
    //Fund Information section
    public selectedInvestmentProgram?: string;
    public investmentProgram!: string[];
    public fundDetails!: FundInformationVm[];
    public isStadion?: boolean;
    public isMas?: boolean;
    public isPcra?: boolean;
    public isIda?: boolean;
    //Plan setting section
    public preEnrollmentStartDate!: Date;
    public transitionPageStartDate!: Date;
    public bfyRedirectionStartDate!: Date;
}

export class preEnrollmentFundDetailVm {
    public fundId!: number;
    public cusip!: string;
    public fundName!: string;
    public assetCategoryNumber!: number;
    public assetCategoryName!: string;
    public prospectusUrl!: string;
    public prospectusLinkDisplay!: CodeReferenceVm;
    public factSheetUrl!: string;
    public displayOrder!: number;
    public tickerSymbol!: string;
    public allocationPercentage!: number;
    public footNoteText!: string;
    public footnoteType!: CodeReferenceVm;
    public isDefaultFund!: boolean;
    public performanceYtd?: number;
    public oneMonthRor?: number;
    public threeMonthRor?: number;
    public oneYearRor?: number;
    public threeYearRor?: number;
    public fiveYearRor?: number;
    public tenYearRor?: number;
    public sinceInceptionRor?: number;
    public inceptionDate?: Date;
    public rorEffectiveDate?: Date;
}

export class preEnrollmentAssetCategoryDetailsVm {
    public assetCategoryNumber!: number;
    public assetCategoryName!: string;
    public assetCategoryDisplayOrder!: number;
    public contentId!: string;
}

export class PreEnrollmentFundAllocationVm {
    public cusip!: string;
    public allocationPercentage!: number;

    constructor(params?: Partial<PreEnrollmentFundAllocationVm>) {
        Object.assign(this, params);
    }
}

export class GetTargetDateFundRequestVm {
    public dateOfBirth!: Date;
    public preEnrollPlanId!: string;

    constructor(params?: Partial<GetTargetDateFundRequestVm>) {
        Object.assign(this, params);
    }
}

export class GetTargetDateFundResponseVm {
    public fundDetails!: preEnrollmentFundDetailVm[];
    public isFundUpdated!: boolean;
}

export interface StateListVm {
    stateList: CodeReferenceVm[];
}

export class ContributionValidations {
    HowMuchEachRequired = false;
    MaximumOfRequired = false;
    MaxLessThanEachYear = false;
    MaxLessThanSumContributions = false;
    SumContributionsGreaterThanHundred = false;
    OfWhatYearRequired = false;
    StartingInRequired = false;
    IndividualContributionGreaterThanHundred = false;
    ContributionAmountGreaterThanMax = false;
    ContributionAmountGreaterThanMin = false;
    ContributionPercentGreaterThanMax = false;
    ContributionPercentLessThanMin = false;
    TotalPercentContributionGreaterThanHundred = false;
    TotalPercentContributionGreaterThanMax = false;
    TotalAmountContributionGreaterThanMax = false;
    TotalBonusPercentContributionGreaterThanHundred = false;
    TotalBonusPercentContributionGreaterThanMax = false;
    TotalBonusAmountContributionGreaterThanMax = false;

    constructor(init?: Partial<ContributionValidations>) {
        Object.assign(this, init);
    }
}

export class PreEnrollmentAdminDetailsVm {
    public isPreTax!: boolean;
    public isRoth!: boolean;
    public isBonusPreTax!: boolean;
    public isBonusRoth!: boolean;
    public isAfterTax!: boolean;
    public onlineContributionsAllowed!: boolean;

    //additional information
    public preTaxContributionType!: string;
    public rothContributionType!: string;
    public bonusPreTaxContributionType!: string;
    public bonusRothContributionType!: string;
    public afterTaxContributionType!: string;
    public funds!: preEnrollmentFundDetailVm[];
    public assetCategories!: preEnrollmentAssetCategoryDetailsVm[];

    constructor(init?: Partial<PreEnrollmentAdminDetailsVm>) {
        Object.assign(this, init);
    }
}

export enum ContributionSourceTypes {
    PreTax = 'Pre-Tax',
    Roth = 'Roth',
    BonusPreTax = 'Bonus Pre-Tax',
    BonusRoth = 'Bonus Roth',
    AfterTax = 'After-Tax',
}
